import { Rule } from 'antd/lib/form';
import { Config } from './config';

export const URL = (config?: Config): Rule => ({
  ...config,
  type: 'regexp',
  pattern: new RegExp('/(w+:{0,1}w*@)?(S+)(:[0-9]+)?(/|/([w#!:.?+=&%@!-/]))?/'),
  required: true,
});
